export enum PromoCode {
	HEALTH_PLAN_FREE = 'HEALTH_PLAN_FREE',
}
